import React from 'react';
import { FormContext } from '../FormContext';
import { RowType } from '../RowType';
import IsAccountSearchableForNewUsers from './IsAccountSearchableForNewUsersRow';
import LabelAndInputRow from './LabelAndInputRow';
import PostalCodeAndPhoneInputRow from './PostalCodeAndPhoneInputRow';
import SocialMediaLinkInputRow from './SocialMediaLinkInputRow';

export default function RowByType() {
	const formContext = React.useContext(FormContext);
	const {
		rowOptions: { rowType },
	} = formContext;

	switch (rowType) {
		case RowType.LabelAndInput:
			return <LabelAndInputRow />;
		case RowType.PostalCodeAndPhone:
			return <PostalCodeAndPhoneInputRow />;
		case RowType.IsAccountSearchableForNewUsers:
			return <IsAccountSearchableForNewUsers />;
		case RowType.SocialMediaLinkInputRow:
			return <SocialMediaLinkInputRow />;
		default:
			throw new Error('Invalid row type');
	}
}
